<div [id]="idModal" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Pesquisar Transportadora
                </h4>        
                
                <span class="float-right">
                    <div class="btn-group">
                        <button type="button" class="btn btn-light" (click)="search()">
                            <i class="fas fa-search" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-light" (click)="clearFilter()">
                            <i class="fas fa-eraser" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn" [class.btn-light]="!filterCollapse.isFilterDirty" [class.btn-danger]="filterCollapse.isFilterDirty"
                            (click)="filterCollapse.toggleCollapse()">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="filterCollapse.collapseIcon" aria-hidden="true"></i>
                        </button>
                    </div>                
                </span> 
            </div>
            <div class="modal-body" #modalBody>
                <div class="row">
                    <div class="col-12">
                        <sgt-transportadora-filter-collapse
                            [filter]="filter"
                            [situacao]="situacao"
                            #filterCollapse>
                        </sgt-transportadora-filter-collapse>
                    </div>
                </div> 

                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped table-hover datatables table-transportadoras filter-modal" [id]="idDataTable">
                            <thead>
                                <tr>
                                    <th class="col-options"></th>
                                    <th class="col-codigo-integracao-erp text-right">Código ERP</th>
                                    <th class="col-nome">Nome</th>
                                    <th class="col-nome-fantasia">Nome Fantasia</th>
                                    <th class="col-cnpj-cpf">CNPJ / CPF</th>
                                    <th class="col-situacao text-center">Situação</th>
                                </tr>
                            </thead>
                        </table>                      
                    </div>
                </div>                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>